module.exports = __webpack_public_path__ + "img/HC2013-152.b8238b8e.jpg";